import { NumberInput, required, useNotify, useRefresh, Button } from "react-admin";
import { Grid } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";

import { candidateRequests } from "api/candidateApi";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const EditExamGradeDialog = ({ candidacyId, campaignExamId, disabled, grade }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const number = grade ? grade.match(/\d+(?:\.\d+)?/)?.[0] || "" : "";

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      candidateRequests.candidacyExamGrades(candidacyId, campaignExamId),
      { grade: parseFloat(data.parsedGrade) },
      "PUT",
    );
    notify("Оценката е променена успешно", { type: "success" });
    refresh();
  };
  return (
    <FormModal
      titleContent="Промяна на оценка от КСК"
      onConfirm={handleConfirm}
      defaultValues={{ parsedGrade: number }}
      triggerButton={
        <Button
          startIcon={<EditNoteIcon />}
          variant="contained"
          disabled={disabled}
          label="Промяна на оценки от КСК"
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={5}
          sm={5}
        >
          <NumberInput
            source="parsedGrade"
            label="Оценка"
            min={2}
            max={6}
            step={0.01}
            validate={required()}
            fullWidth
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default EditExamGradeDialog;
